/**
 * Compatibility NgModule that imports ng-bootstrap v17 standalone components directly.
 *
 * In Angular 18, importing ng-bootstrap's own NgModule wrappers (NgbModule, NgbNavModule, etc.)
 * into a regular NgModule raises NG3004 because those wrappers only contain standalone components
 * with no declarations. This module re-wraps the same standalone components inside a local NgModule
 * so Angular's compiler can validate the metadata within the app's own compilation unit.
 *
 * Usage: replace all NgbModule / NgbNavModule / NgbCollapseModule / etc. imports with NgbCompatModule.
 */
import { NgModule } from '@angular/core';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
  NgbAccordionToggle,
  NgbAlert,
  NgbCarousel,
  NgbCollapse,
  NgbDatepicker,
  NgbDatepickerContent,
  NgbDatepickerMonth,
  NgbDropdown,
  NgbDropdownAnchor,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbHighlight,
  NgbInputDatepicker,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavLinkButton,
  NgbNavOutlet,
  NgbNavPane,
  NgbPagination,
  NgbPaginationEllipsis,
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationNext,
  NgbPaginationNumber,
  NgbPaginationPages,
  NgbPaginationPrevious,
  NgbPopover,
  NgbProgressbar,
  NgbProgressbarStacked,
  NgbRating,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbScrollSpyItem,
  NgbScrollSpyMenu,
  NgbSlide,
  NgbTimepicker,
  NgbToast,
  NgbToastHeader,
  NgbTooltip,
  NgbTypeahead,
} from '@ng-bootstrap/ng-bootstrap';

const NGB_STANDALONE_COMPONENTS = [
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
  NgbAccordionToggle,
  NgbAlert,
  NgbCarousel,
  NgbCollapse,
  NgbDatepicker,
  NgbDatepickerContent,
  NgbDatepickerMonth,
  NgbDropdown,
  NgbDropdownAnchor,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbHighlight,
  NgbInputDatepicker,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavLinkButton,
  NgbNavOutlet,
  NgbNavPane,
  NgbPagination,
  NgbPaginationEllipsis,
  NgbPaginationFirst,
  NgbPaginationLast,
  NgbPaginationNext,
  NgbPaginationNumber,
  NgbPaginationPages,
  NgbPaginationPrevious,
  NgbPopover,
  NgbProgressbar,
  NgbProgressbarStacked,
  NgbRating,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbScrollSpyItem,
  NgbScrollSpyMenu,
  NgbSlide,
  NgbTimepicker,
  NgbToast,
  NgbToastHeader,
  NgbTooltip,
  NgbTypeahead,
];

@NgModule({
  imports: NGB_STANDALONE_COMPONENTS,
  exports: NGB_STANDALONE_COMPONENTS,
})
export class NgbCompatModule {}
